<h2 mat-dialog-title>Reject payment request</h2>

<mat-dialog-content>
  <p>
    Use this when {{ data.supplierName || 'the supplier' }} could not be paid (for example the card was declined).
    The reason is shown to the supplier, who can fix it and ask again an hour after this request was made.
  </p>
  <mat-form-field appearance="outline" class="reason">
    <mat-label>Reason</mat-label>
    <textarea matInput rows="3" [maxlength]="maxLength" [(ngModel)]="reason"
      placeholder="e.g. Card declined by the bank — please check the card number"></textarea>
    <mat-hint align="end">{{ reason.length }} / {{ maxLength }}</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button type="button" (click)="dialogRef.close(null)">Back</button>
  <button mat-flat-button type="button" color="warn" [disabled]="!valid" (click)="dialogRef.close(reason.trim())">
    Reject request
  </button>
</mat-dialog-actions>
